import React, { useEffect, useState } from "react";
import StyledNavbar from "./style";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import GroupIcon from "@material-ui/icons/Group";
import ReceiptIcon from "@material-ui/icons/Receipt";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import AssignmentIcon from "@material-ui/icons/Assignment";
import LocalLibraryIcon from "@material-ui/icons/LocalLibrary";
import ArrowDropDownCircleIcon from "@material-ui/icons/ArrowDropDownCircle";
// import { useHistory } from "react-router-dom";

import Hamburger from "./NavbarSmall";

const NavbarComponent = props => {
  // const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick2 = event => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };
  const [live, setLive] = useState(false);

  useEffect(() => {
    const end_timestamp = 1622487600;
    // web3_obj && web3_obj.init();
    var x = setInterval(function () {
      // Get today's date and time
      const currentDate = new Date();
      const now = parseInt(currentDate.getTime().toString().slice(0, -3));

      // Find the distance between now and the count down date
      var distance = end_timestamp - now;

      // Time calculations for days, hours, minutes and seconds
      // var days = Math.floor(distance / (60 * 60 * 24));
      // var hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60));
      // var minutes = Math.floor((distance % (60 * 60)) / 60);
      // var seconds = Math.floor(distance % 60);

      // Display the result in the element with id="demo"
      // setTimer({
      //   days: days,
      //   hours: hours,
      //   minutes: minutes,
      //   seconds: seconds,
      // });

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        // setTimer();
        setLive(true);
      }
    }, 1000);
  }, []);

  return (
    <StyledNavbar style={{ position: "fixed", width: "100vw", zIndex: 1 }}>
      <div className="wrapper fadeIn">
        <div
          className="logo_div"
          onClick={() => props.history.push({ pathname: "/" })}
        >
          <img className="logo" src="/cefaSmall.png" alt="cefa logo" />
        </div>
        <div className="links_div">
          <div className="link">
            <Button
              className="link-drop"
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              COMMUNITY
            </Button>
            <Menu
              className="menuu"
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose}>
                <a
                  style={{
                    textDecoration: "none",
                    color: "#0f3137",
                    fontFamily: "Poppins",
                    fontStyle: "normal",
                    fontWeight: "500",
                    fontSize: "15px",
                    lineHeight: "24px",
                    letterSpacing: "1.15px",
                  }}
                  href="https://cefatoken.medium.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Medium
                </a>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <a
                  style={{
                    textDecoration: "none",
                    color: "#0f3137",
                    fontFamily: "Poppins",
                    fontStyle: "normal",
                    fontWeight: "500",
                    fontSize: "15px",
                    lineHeight: "24px",
                    letterSpacing: "1.15px",
                  }}
                  href="https://www.youtube.com/playlist?list=PLfb8Qomp_Dd-9WD2tLcjNV3jGp2ncpUV0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Youtube
                </a>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <a
                  style={{
                    textDecoration: "none",
                    color: "#0f3137",
                    fontFamily: "Poppins",
                    fontStyle: "normal",
                    fontWeight: "500",
                    fontSize: "15px",
                    lineHeight: "24px",
                    letterSpacing: "1.15px",
                  }}
                  href="https://twitter.com/CEFAToken"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Twitter
                </a>
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <a
                  style={{
                    textDecoration: "none",
                    color: "#0f3137",
                    fontFamily: "Poppins",
                    fontStyle: "normal",
                    fontWeight: "500",
                    fontSize: "15px",
                    lineHeight: "24px",
                    letterSpacing: "1.15px",
                  }}
                  href="https://discord.gg/Qek3eMeHDk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Discord
                </a>
              </MenuItem>
              {props.match.path !== "/harvestround" && (
                <MenuItem onClick={handleClose}>
                  <a
                    style={{
                      textDecoration: "none",
                      color: "#0f3137",
                      fontFamily: "Poppins",
                      fontStyle: "normal",
                      fontWeight: "500",
                      fontSize: "15px",
                      lineHeight: "24px",
                      letterSpacing: "1.15px",
                    }}
                    href="https://t.me/CEFAToken"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Telegram
                  </a>
                </MenuItem>
              )}
            </Menu>
          </div>
          <div className="link">
            <Button
              className="link-drop"
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick2}
            >
              DOCS
            </Button>
            <Menu
              className="menuu"
              id="simple-menu"
              anchorEl={anchorEl2}
              keepMounted
              open={Boolean(anchorEl2)}
              onClose={handleClose2}
            >
              <MenuItem onClick={handleClose2}>
                <p
                  style={{
                    textDecoration: "none",
                    color: "#0f3137",
                    fontFamily: "Poppins",
                    fontStyle: "normal",
                    fontWeight: "500",
                    fontSize: "15px",
                    lineHeight: "20px",
                    letterSpacing: "1.15px",
                  }}
                  onClick={() => props.history.push({ pathname: "whitepaper" })}
                >
                  Whitepaper
                </p>
              </MenuItem>
              <MenuItem onClick={handleClose2}>
                <p
                  style={{
                    textDecoration: "none",
                    color: "#0f3137",
                    fontFamily: "Poppins",
                    fontStyle: "normal",
                    fontWeight: "500",
                    fontSize: "15px",
                    lineHeight: "20px",
                    letterSpacing: "1.15px",
                  }}
                  onClick={() =>
                    props.history.push({ pathname: "whitepaper2" })
                  }
                >
                  Whitepaper-Text
                </p>
              </MenuItem>
              <MenuItem onClick={handleClose2}>
                <p
                  style={{
                    textDecoration: "none",
                    color: "#0f3137",
                    fontFamily: "Poppins",
                    fontStyle: "normal",
                    fontWeight: "500",
                    fontSize: "15px",
                    lineHeight: "20px",
                    letterSpacing: "1.15px",
                  }}
                  onClick={() => props.history.push({ pathname: "litepaper" })}
                >
                  Litepaper
                </p>
              </MenuItem>
              <MenuItem onClick={handleClose2}>
                <p
                  style={{
                    textDecoration: "none",
                    color: "#0f3137",
                    fontFamily: "Poppins",
                    fontStyle: "normal",
                    fontWeight: "500",
                    fontSize: "15px",
                    lineHeight: "24px",
                    letterSpacing: "1.15px",
                  }}
                  onClick={() => props.history.push({ pathname: "audit" })}
                >
                  Audit Report
                </p>
              </MenuItem>
            </Menu>
          </div>
          <a
            className="link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://bscscan.com/address/0x4e2b998ecb7b6ef78c6a93ac1f5df9e6063a8fff"
          >
            CONTRACT
          </a>
          <p
            className="link"
            onClick={() => props.history.push({ pathname: "tutorial" })}
          >
            TUTORIAL
          </p>
          <p
            className="link"
            // href="#none"
            onClick={() => props.history.push("/referral")}
          >
            REFERRALS
          </p>
          <a className="link sm" style={{ color: "#FDCD0B" }} href="#none">
            MORE
          </a>
        </div>
        <div className="buyButton_div">
          {/* <Button
            style={{ textTransform: "none" }}
            variant="contained"
            className={live ? "none" : "buyButton"}
            onClick={() => props.history.push({ pathname: "whitepaper" })}
          >
            Learn More
          </Button> */}
          <Button
            style={{ textTransform: "none" }}
            variant="contained"
            className="buyButton"
            onClick={() =>
              props.history.push({
                pathname: `sale`,
              })
            }
          >
            <span style={{ textDecoration: "none", color: "#1c454c" }}>
              Participate
            </span>
          </Button>

          <span className="hamBtnDiv sm">
            <Hamburger />
          </span>
        </div>
      </div>
    </StyledNavbar>
  );
};
export default NavbarComponent;
